/// <reference path="../../HTML/Form/Form.ts" />
/// <reference path="../Form/FormController.ts" />
/// <reference path="../../HTML/Tag.ts" />
/// <reference path="../../HTML/Anchor.ts" />
/// <reference path="../../HTML/HtmlService.ts" />
namespace HA.Core.Controller.Page {
    import Tag = HA.Core.HTML.Tag;
    import Form = HA.Core.HTML.Form.Form;
    import FormController = HA.Core.Controller.Form.FormController;
    import HtmlService = HA.Core.HTML.Service.HtmlService;
    import Anchor = HA.Core.HTML.Anchor;
    import Div = HA.Core.HTML.Div;

    export class PageController extends Controller {
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            this.createHtml();
            this.initForms();
            this.initControllers();
            this.createMenu();
        }

        protected createMenu() {
            const controllersData = toMap(this.get("controllers"));
            if (!controllersData || !controllersData.get("pm")) {
                return;
            }
            const pm = toMap(controllersData.get("pm"));
            if (pm.size > 0) {
                const tag: Tag = this.getTag();
                const t = tag.findByAttribute("tt=pa");
                if (t) {
                    const div = new Tag({
                        c: [
                            {
                                attributes: [
                                    {
                                        n: "id",
                                        v: "pagemenu",
                                    },
                                ],
                                classes: ["xscroll", "ayyellow"],
                                t: "fc",
                            }],
                        class: "fixp",
                    });
                    t.addFistChild(div);
                    const flexContainer = div.findById("pagemenu");
                    pm.forEach((item: { n: any, a: string, html: any}) => {
                        const content = item.html ? [item.html] : item.n;
                        const d = new Div({
                            c: content,
                            class: "item",
                        });
                        const a = new Anchor(toMap({
                            attributes: [
                                {
                                    n: "d",
                                    v: item.a,
                                },
                                {
                                    n: "t",
                                    v: "reloadApp",
                                },
                            ],
                        }));
                        a.appendChild(d);
                        flexContainer.appendChild(a);
                    });
                }
            }
        }

        protected createHtml() {
            if (this.get("pd")) {
                this.getTag().addClass("app_page");
                this.getTag().appendChild(HtmlService.createHtml(toMap(this.get("pd")), this.getServiceManager()));
                /*const tagC = HtmlService.createHtml(toMap(this.get("pd")), this.getServiceManager());
                if (!(tagC instanceof HTML.AppMenu)) {
                    this.getTag().appendChild(tagC.getChildren()[0]);
                } else {
                this.getTag().appendChild(tagC.getElement().getChildren()[0]);
                 }*/
            }
        }

        protected initForms() {
            const tag = this.getTag();
            const forms = tag.fetchByTagName("form");
            forms.forEach((form: Tag) => {
                if (form.getAttribute("i")) {
                    return;
                }
                const data = new Map();
                data.set("tag", new Form(form));
                new FormController(data);
            });
        }
    }
}
